import { render, staticRenderFns } from "./NoConversationSelected.vue?vue&type=template&id=45f48294&scoped=true&"
import script from "./NoConversationSelected.vue?vue&type=script&lang=js&"
export * from "./NoConversationSelected.vue?vue&type=script&lang=js&"
import style0 from "./NoConversationSelected.vue?vue&type=style&index=0&id=45f48294&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f48294",
  null
  
)

export default component.exports